import { render, staticRenderFns } from "./Fretboard.vue?vue&type=template&id=34965abe&scoped=true&"
import script from "./Fretboard.vue?vue&type=script&lang=js&"
export * from "./Fretboard.vue?vue&type=script&lang=js&"
import style0 from "./Fretboard.vue?vue&type=style&index=0&id=34965abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34965abe",
  null
  
)

export default component.exports